import { parseDate } from 'utils';

const isExpired = (expirationDate: number) =>
  new Date(parseDate(expirationDate)) < new Date();

export default isExpired;
